

import React from "react";
import { FaPlus, FaCalendarAlt } from "react-icons/fa";
import MedtrustHeader from "../../Compoents/MedtrustHeader";
import MedtrustFooter from "../../Compoents/MedtrustFooter";
import BreadcrumbArea from "../../ShearOne/BreadcrumbArea";
import HospitalLayout from "./HospitalLayout";

const PartnerHospital = () => {
 
  const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'Partner Hospital', active: true }
    ];

  return (
    <div className="min-h-screen bg-[#f5f7fa]">
      <MedtrustHeader />
      <BreadcrumbArea
                    title="Partner Hospital"
                    backgroundImage="assets/imgs/appointment/appointment.png"
                    links={breadcrumbLinks}
                />

     <HospitalLayout />

      <MedtrustFooter />
    </div>
  );
};

export default PartnerHospital;